<template>
  <div>
    <v-expansion-panel class="bodyExpansion" v-model="openPanel" expand>
      <v-expansion-panel-content>
        <template v-slot:actions>
          <v-icon color="#27DABC">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
          <div class="titleExpansion">{{text}}</div>
        </template>

        <div class="codeBody">
          <v-card class="language">
            <v-btn color="#27DABC">JSON</v-btn>
          </v-card>
          <v-card class="code" width="100vw">
            <pre>{{code}}</pre>
          </v-card>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
export default {
  name: 'CodeSampleView',
  props: {
    code: {
      type: Object
    },
    text: {
      type: String
    },
    openPanel: {
      type: Array
    }
  }
}
</script>

<style lang="css" scoped>
.bodyExpansion {
  margin-bottom: 2%;
  box-shadow: 0px 0px 1px ;
}
.titleExpansion  {
  font-family: 'Paralucent';
  font-weight: 500;
  font-size: 14px;
  padding: 10px 0px;
  color: #2e4369;
}
.codeBody {
  display: flex;
}
.code {
  border-radius: 0px;
  background-color: #28292d;
  color: #afb8bb;
  font-size: 13px;
  padding: 1.2% 3%;
  overflow-x: auto;
}
.language {
  border-radius: 0px;
  padding: 1% 2%;
  background-color: #202224;
}
</style>



// WEBPACK FOOTER //
// src/components/documentation/CodeSampleView.vue